/**
 * Slices a given number of items from an array
 * @param array Any Array
 * @param count The number of items to be returned
 * @returns a the split array
 */
export const take = <T>(array: T[], count: number): T[] => array.slice(0, count);
